import { Typography, TextField, Grid, Button, Card } from "@mui/material";
import { fileUploadSubmittal } from "modules/agentMySecurity/services/embeddingsService";
import { useDropzone } from "react-dropzone";
import { UploadContainer, UploadFilesContainer, UploadUploadContainer } from "../ragdad.styled";
import UploadIcon from '@mui/icons-material/Upload';
import Uploadfunction from "assets/UploadIcon";
import { AuthContext } from "core/contexts/auth/auth";
import { useContext } from "react";


function Dropzone() {
    const { checkAuthToken } = useContext(AuthContext);
    const { getRootProps, getInputProps, acceptedFiles } = useDropzone({});
  
    // Show the accepted files as a list
    const files = acceptedFiles.map((file) => (
      <li key={file.path}>
        {file.path} - {file.size} bytes
      </li>
    ));
    
    // Submit the files for processing
    async function handleSubmit(formData) {
        const token = await checkAuthToken();
        fileUploadSubmittal(token, formData);
    }

    return (
      <UploadContainer>
        <UploadUploadContainer>
            <div {...getRootProps({ className: "dropzone" })}>
                <input {...getInputProps()} />
                <div className="p-2">
                    <Uploadfunction/>
                </div>
                <span className="d-flex flex-column">
                    <p className="p-2">Drag & Drop Some Files Here</p>
                    <strong className="p-2">OR</strong>
                    <Button variant="contained" className="p-2 mt-2">Select a File</Button>
                </span>
            </div>
        </UploadUploadContainer>
        <UploadFilesContainer>
            { files.length > 0 && <div>
                <p className="p-2">Selected files</p>
                <ul className="p-2">{files}</ul>
                <Button
                    variant="contained"
                    className="p-2 mt-2"
                    onClick={() => {
                        // Collect selected files
                        const formData = new FormData();

                        acceptedFiles.forEach((file) => {
                            formData.append("files", file);
                        });

                        handleSubmit(formData);
                    }}
                    >Upload Files</Button>
            </div>
            }
        </UploadFilesContainer>
      </UploadContainer>
    );
}
  
export default Dropzone;


